import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";

const EmptyState = ({ onSetup, ...props }) => {
  const navigate = useNavigate();

  const handleSetupClick = () => {
    if (onSetup) {
      onSetup();
    } else {
      navigate("/dashboard/townhall/add");
    }
  };

  return (
    <div className="empty-state-container" {...props}>
      <div
        className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto"
        data-testid="townhall-empty-state">
        <WebIcon
          icon="TownHallHover"
          size="large"
          className="mb-6 w-[100px] h-[100px]"
        />
        <h2 className="heading-large whitespace-nowrap font-bold text-lighterGrey mb-4">
          TownHall Empty
        </h2>
        <p className="text-bold-x font-normal text-lighterGrey mb-8">
          There&apos;s nothing to show here
        </p>
        <Button
          text="SET UP A NEW TOWNHALL"
          color="primary"
          className="w-full px-6 py-3 text-white font-medium"
          customBgColor="primary"
          customTextColor="white"
          onClick={handleSetupClick}
          data-testid="create-townhall-btn"
        />
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  onSetup: PropTypes.func,
};

export default EmptyState;
